import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class DropDown extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    // Show
    $(document).on('click', '.dropdown:not(.is-hoverable):not([disabled])', (event) => {
      return this.onClick(event);
    });

    // Hide
    $(document).on('click', () => {
      $('.dropdown:not(.is-hoverable)').removeClass('is-active');
    });

  }

  onClick(event) {

    let self = $(event.currentTarget);
    event.stopPropagation();
    self.toggleClass('is-active');

  }

}